export enum AudioStream {
  music = 'music',
  voiceOver = 'voiceOver',
  breathing = 'breathing',
}

// One value per audio file. String values match the Dart enum member names so
// they can be used as stable storage keys and mapped to file URLs by the infra
// layer (AudioTrackRegistry).
export enum AudioTrackId {
  n01 = 'n01',
  n02 = 'n02',
  n03 = 'n03',
  n04 = 'n04',
  n05 = 'n05',
  n06 = 'n06',
  n07 = 'n07',
  n08 = 'n08',
  n09 = 'n09',
  n10 = 'n10',
  n11 = 'n11',
  n12 = 'n12',
  n13 = 'n13',
  n14 = 'n14',
  n15 = 'n15',
  n16 = 'n16',
  n17 = 'n17',
  n18 = 'n18',
  n19 = 'n19',
  n20 = 'n20',
  n21 = 'n21',
  n22 = 'n22',
  n23 = 'n23',
  n24 = 'n24',
  n25 = 'n25',
  n26 = 'n26',
  n27 = 'n27',
  n28 = 'n28',
  n29 = 'n29',
  n30 = 'n30',
  anulomVilomPrep2 = 'anulomVilomPrep2',
  anulomVilomPrep3 = 'anulomVilomPrep3',
  bhastrikaExhale = 'bhastrikaExhale',
  bhastrikaInhale = 'bhastrikaInhale',
  bhastrikaPrep1 = 'bhastrikaPrep1',
  bhramariPrep1 = 'bhramariPrep1',
  breathworkClosing = 'breathworkClosing',
  breathworkPrep1 = 'breathworkPrep1',
  breathworkPrep2 = 'breathworkPrep2',
  chandraBedhanaPrep1 = 'chandraBedhanaPrep1',
  closeYourEyesAndCenterYourself = 'closeYourEyesAndCenterYourself',
  closeYourEyesSettleBodyCalmMind = 'closeYourEyesSettleBodyCalmMind',
  exhaleCount8 = 'exhaleCount8',
  exhaleLeft = 'exhaleLeft',
  exhaleMurcha = 'exhaleMurcha',
  exhaleRight = 'exhaleRight',
  exhaleSoundBee15Sec = 'exhaleSoundBee15Sec',
  exhaleSoundBee30Sec = 'exhaleSoundBee30Sec',
  exhaleSound02Sec = 'exhaleSound02Sec',
  exhaleSound04Sec = 'exhaleSound04Sec',
  exhaleSound06Sec = 'exhaleSound06Sec',
  exhaleSound08Sec = 'exhaleSound08Sec',
  exhaleSound12Sec = 'exhaleSound12Sec',
  exhaleSound20Sec = 'exhaleSound20Sec',
  exhaleSound30Sec = 'exhaleSound30Sec',
  exhaleSound300ms = 'exhaleSound300ms',
  exhaleSoundKapalabhati = 'exhaleSoundKapalabhati',
  exhaleSoundUjjayi2Sec = 'exhaleSoundUjjayi2Sec',
  exhaleSoundUjjayi4Sec = 'exhaleSoundUjjayi4Sec',
  exhaleThroughMouth = 'exhaleThroughMouth',
  exhaleThroughNose = 'exhaleThroughNose',
  exhaleWord = 'exhaleWord',
  exhaleWordBee = 'exhaleWordBee',
  exhaleWordFast = 'exhaleWordFast',
  getReady = 'getReady',
  hold = 'hold',
  holdBreathCount7 = 'holdBreathCount7',
  holdFemale = 'holdFemale',
  inFast = 'inFast',
  inhale70Percent = 'inhale70Percent',
  inhaleLeft = 'inhaleLeft',
  inhaleMouth = 'inhaleMouth',
  inhaleNose = 'inhaleNose',
  inhaleQuietlyCount4 = 'inhaleQuietlyCount4',
  inhaleRight = 'inhaleRight',
  inhaleSmoothly = 'inhaleSmoothly',
  inhaleSound02Sec = 'inhaleSound02Sec',
  inhaleSound04Sec = 'inhaleSound04Sec',
  inhaleSound06Sec = 'inhaleSound06Sec',
  inhaleSound08Sec = 'inhaleSound08Sec',
  inhaleSound12Sec = 'inhaleSound12Sec',
  inhaleSound20Sec = 'inhaleSound20Sec',
  inhaleSound30Sec = 'inhaleSound30Sec',
  inhaleSoundUjjayi2Sec = 'inhaleSoundUjjayi2Sec',
  inhaleSoundUjjayi4Sec = 'inhaleSoundUjjayi4Sec',
  inhaleSound300ms = 'inhaleSound300ms',
  inhaleTongue = 'inhaleTongue',
  inhaleWord = 'inhaleWord',
  inhaleWordFast = 'inhaleWordFast',
  kapalabhatiPrep3 = 'kapalabhatiPrep3',
  keepChestOpenBodyRelaxedAlertCloseEyesDeepBreathsCenterFocus = 'keepChestOpenBodyRelaxedAlertCloseEyesDeepBreathsCenterFocus',
  khechariMudraPrep1 = 'khechariMudraPrep1',
  khechariMudraPrep2 = 'khechariMudraPrep2',
  khechariMudraPrep3 = 'khechariMudraPrep3',
  khechariMudraPrep4 = 'khechariMudraPrep4',
  kumbhakaPrep1 = 'kumbhakaPrep1',
  kumbhakaPrep2 = 'kumbhakaPrep2',
  kumbhakaPrep3 = 'kumbhakaPrep3',
  kumbhakaPrep4 = 'kumbhakaPrep4',
  maintainRhythmicBreathingPattern = 'maintainRhythmicBreathingPattern',
  meditationMusic = 'meditationMusic',
  metronome = 'metronome',
  murchaPrep1 = 'murchaPrep1',
  murchaPrep2 = 'murchaPrep2',
  murchaPrep3 = 'murchaPrep3',
  nadiShodanaCompletion = 'nadiShodanaCompletion',
  nadiShodanaPrep1 = 'nadiShodanaPrep1',
  nadiShodanaPrep2 = 'nadiShodanaPrep2',
  nadiShodanaPrep3 = 'nadiShodanaPrep3',
  outFast = 'outFast',
  placePalmsOnKneesPrep = 'placePalmsOnKneesPrep',
  plaviniPrep1 = 'plaviniPrep1',
  plaviniPrep2 = 'plaviniPrep2',
  plaviniPrep3 = 'plaviniPrep3',
  roundClosing = 'roundClosing',
  roundStartPrep = 'roundStartPrep',
  samaVritti3 = 'samaVritti3',
  samaVritti4 = 'samaVritti4',
  samaVritti5 = 'samaVritti5',
  sitaliPrep1 = 'sitaliPrep1',
  sitaliPrep2 = 'sitaliPrep2',
  sitComfortableSpineStraightRelaxHandsOnKnees = 'sitComfortableSpineStraightRelaxHandsOnKnees',
  sitComfortableSpineStraightShouldersRelaxedGazeForwardPrep = 'sitComfortableSpineStraightShouldersRelaxedGazeForwardPrep',
  sitComfortableSpineStraightShouldersRelaxedLeftHandOnKneeChinMudraPrep = 'sitComfortableSpineStraightShouldersRelaxedLeftHandOnKneeChinMudraPrep',
  sitComfortablyInPositionOfYourChoiceWithYourSpineStraightAndShouldersRelaxedPrep = 'sitComfortablyInPositionOfYourChoiceWithYourSpineStraightAndShouldersRelaxedPrep',
  sitComfortablyOrLieDown = 'sitComfortablyOrLieDown',
  sitQuietlyEyesClosedBreathToItsNaturalRhythm = 'sitQuietlyEyesClosedBreathToItsNaturalRhythm',
  sitkariPrep1 = 'sitkariPrep1',
  sitkariPrep2 = 'sitkariPrep2',
  suryaBhedanaPrep1 = 'suryaBhedanaPrep1',
  swallowAndHold = 'swallowAndHold',
  takeAFewNaturalBreathsSettleYourMindAndBody = 'takeAFewNaturalBreathsSettleYourMindAndBody',
  takeFewDeepBreathsPrepTalk = 'takeFewDeepBreathsPrepTalk',
  takeFewMinutesHowBodyFeelsCoolerRefreshedRelaxed = 'takeFewMinutesHowBodyFeelsCoolerRefreshedRelaxed',
  takeFewMinutesHowBodyFeelsEnergizedClearPresent = 'takeFewMinutesHowBodyFeelsEnergizedClearPresent',
  tummoPrep1 = 'tummoPrep1',
  tummoPrep2 = 'tummoPrep2',
  tummoPrep3 = 'tummoPrep3',
  ujjayiPrep1 = 'ujjayiPrep1',
  ujjayiPrep2 = 'ujjayiPrep2',
  vishamaVrittiPrep1 = 'vishamaVrittiPrep1',
  vishamaVrittiPrep2 = 'vishamaVrittiPrep2',
}

const BREATHING_TRACKS = new Set<AudioTrackId>([
  AudioTrackId.exhaleSound02Sec,
  AudioTrackId.exhaleSound04Sec,
  AudioTrackId.exhaleSound06Sec,
  AudioTrackId.exhaleSound08Sec,
  AudioTrackId.exhaleSound12Sec,
  AudioTrackId.exhaleSound20Sec,
  AudioTrackId.exhaleSound30Sec,
  AudioTrackId.exhaleSound300ms,
  AudioTrackId.exhaleSoundBee15Sec,
  AudioTrackId.exhaleSoundBee30Sec,
  AudioTrackId.exhaleSoundKapalabhati,
  AudioTrackId.exhaleSoundUjjayi2Sec,
  AudioTrackId.exhaleSoundUjjayi4Sec,
  AudioTrackId.inhaleSound02Sec,
  AudioTrackId.inhaleSound04Sec,
  AudioTrackId.inhaleSound06Sec,
  AudioTrackId.inhaleSound08Sec,
  AudioTrackId.inhaleSound12Sec,
  AudioTrackId.inhaleSound20Sec,
  AudioTrackId.inhaleSound30Sec,
  AudioTrackId.inhaleSound300ms,
  AudioTrackId.inhaleSoundUjjayi2Sec,
  AudioTrackId.inhaleSoundUjjayi4Sec,
]);

export function getAudioStream(trackId: AudioTrackId): AudioStream {
  if (trackId === AudioTrackId.meditationMusic) return AudioStream.music;
  if (BREATHING_TRACKS.has(trackId)) return AudioStream.breathing;
  return AudioStream.voiceOver;
}
